import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;
const ACCOUNTS = 'accounts';

export default class AccountService {
	static async create(requestBody) {
		return ApiService.PostData(API_URLS.ACCOUNTS, requestBody, ACCOUNTS);
	}

	static async update(customerID, requestBody) {
		return ApiService.PatchData(`${API_URLS.ACCOUNTS}/${customerID}`, requestBody, ACCOUNTS);
	}

	static async createContact(requestBody) {
		return ApiService.PostData(`${API_URLS.ACCOUNTS}/create-contact`, requestBody, ACCOUNTS);
	}

	static async getSignedURL(customerID, requestBody) {
		return ApiService.PostData(`${API_URLS.ACCOUNTS}/${customerID}/${API_URLS.DOCUMENT}`, requestBody, ACCOUNTS);
	}

	static async getQuestionsForKba(customerID) {
		return ApiService.GetData(`${API_URLS.ACCOUNTS}/${customerID}/${API_URLS.KBA}`, ACCOUNTS);
	}

	static async getFundingSourceByUserId(userId) {
		return ApiService.GetData(`accounts/users/${userId}/funding-source`, ACCOUNTS);
	}

	static async getTransactionsByUserId(userId, queryUrl) {
		return ApiService.GetData(`transfers/users/${userId}${queryUrl}`);
	}

	static async tranferFundsToOrginator(userId) {
		return ApiService.PostData(`${API_URLS.ACCOUNTS}/${userId}/${API_URLS.TRANSFERS}`, {}, ACCOUNTS);
	}
	// test: create new endpoint for transaction
	static async getTransactions(queryUrl) {
		return ApiService.GetData(`accounts/transfers/users/${queryUrl}`, ACCOUNTS);
	}

	static async getTransactionsByUserId(userId, queryUrl) {
		return ApiService.GetData(`/transfers/users/${userId}${queryUrl}`, ACCOUNTS);
	}
	static async getPlaidDetails(userId) {
		return ApiService.GetData(`${API_URLS.ACCOUNTS}/${userId}/${API_URLS.PLAID}`, ACCOUNTS);
	}

	static async getTokenForPlaidLink(fundingSourceId) {
		return ApiService.GetData(
			`${API_URLS.FUNDING_SOURCE}/${fundingSourceId}/${API_URLS.PLAID_LINK_TOKEN}`,
			ACCOUNTS
		);
	}

	static async updatePlaidSatus() {
		return ApiService.PatchData(API_URLS.UPADTE_PLAID_STATUS, {}, ACCOUNTS);
	}

	static async getBuxChannelCodes() {
		return ApiService.GetData(API_URLS.BUX_CHANNEL_CODES, ACCOUNTS);
	}

	static async getRecordTopup(userId, queryUrl) {
		return ApiService.GetData(`${API_URLS.GET_RECORD_TOPUP_BY_USER}/${userId}${queryUrl}`, ACCOUNTS);
	}

	static async getRecordTopupDetail(id) {
		return ApiService.GetData(`${API_URLS.GET_RECORD_TOPUP_DETAIL}/${id}`, ACCOUNTS);
	}

	static async getRecordCashout(userId, queryUrl) {
		return ApiService.GetData(`${API_URLS.GET_RECORD_CASHOUT_BY_USER}/${userId}${queryUrl}`, ACCOUNTS);
	}

	static async getRecordCashoutDetail(id) {
		return ApiService.GetData(`${API_URLS.GET_RECORD_CASHOUT_DETAIL}/${id}`, ACCOUNTS);
	}

	static async sendChangedPasswordConfirmationNotify(requestBody) {
		return ApiService.PostData(`${API_URLS.CHANGE_PASSWORD_CONFIRMATION_NOTIFY}`, requestBody, ACCOUNTS);
	}

	static async sendKYCVerification(requestBody) {
		return ApiService.PostData(`${API_URLS.ACCOUNTS}/${API_URLS.SEND_KYC_VERIFICATION}`, requestBody, ACCOUNTS);
	}
}
